import { useState, useEffect } from 'react'
import axios from 'axios';
import Main from '../../../../component/Main'
import NewCommonSelect from '../../../../component/common/selectBox/NewCommonSelect';
import SearchBtn from '../../../../component/common/button/SearchBtn';
import NotconnectreasonDataGrid from './NotConnectReasonDataGrid';
import NotconnectreasonlistLayer from './NotConnectReasonList_layer';

function NotConnectReasonList() {

    const [searchParams, setSearchParams] = useState({
        searchGrdc: '',
        searchLoca: '',
        searchEmog: '',
        searchType: '',
        searchGubun: '',
        searchGubunS: '',
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        validationCheckList: []
    });

    const searchParamsAdditional = {
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['번호', '기관명', '미연결구분', '미연결시작시간', '재연결시간', '복구시간', '미연결사유', '비고'];
    const dataColumn = ['SEQ', 'EMOGDESC', 'ERROCLSNAME', 'STARTDATE', 'RECONNECTDATE', 'DIFFDATE', 'ERRONAME', 'ERROETC'];
    const apiCall = '/ptmiapi/nedis/agent/notConnectReasonListSearch.do';
    const apiCntCall = '';
    const excelFileName = 'NEDIS AGENT 미 전송 사유 관리';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const [gubunList, setGubunList] = useState([]);
    const [reasonList, setReasonList] = useState([]);
    const [lastDate, setLastDate] = useState('');
    // 데이터 수정 후 re search
    const [reSearch, setReSearch] = useState(false);

    const fetchInitialData = async () => {
        try {
            const response = await axios.get('/ptmiapi/nedis/agent/nedisCodeListInfo.do');
            setGubunList(response.data.nedisCodeList.gubun || []);
            setReasonList(response.data.nedisCodeList.reason || []);
        } catch (error) {
            console.error('초기 데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchLastData = async (prevLastDate) => {
        try {
            const response = await axios.get('/ptmiapi/nedis/agent/nedisLastdate.do');
            setLastDate(prevLastDate === response.data ? prevLastDate : response.data || []);
        } catch (error) {
            console.error('조회 기준 시간 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        fetchInitialData();
    }, []);

    useEffect(() => {
        fetchLastData(lastDate);
    }, [state.dataList]);

    const [updateParams, setUpdateParams] = useState({
        errocode: '',
        bigo: '',
        erro_seq: ''
    })

    const handleUpdateInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...updateParams,
            [name]: value
        };
        setUpdateParams(newParams);
    };

    const [isModalOpen, setIsModalOpen] = useState({
        modalState: false,
        erro_seq: '',
        errocode: '',
        bigo: ''
    });

    const modalOpen = (erro_seq, errocode, bigo) => {
        setIsModalOpen(prev => ({
            ...prev,
            modalState: true,
            erro_seq: erro_seq,
            errocode: errocode,
            bigo: bigo
        }));
    }
    const modalClose = () => {
        setIsModalOpen(prev => ({
            ...prev,
            modalState: false,
            erro_seq: '',
            errocode: '',
            bigo: ''
        }));
    }

    return (
        <Main>
            <NotconnectreasonlistLayer
                isModalOpen={isModalOpen}
                modalClose={modalClose}
                reasonList={reasonList}
                updateParams={updateParams}
                handleUpdateInputChange={handleUpdateInputChange}
                setReSearch={setReSearch}
            />
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>복구시간</th>
                            <td>
                                <select
                                    name="searchType" // minutediff
                                    id="searchType"
                                    onChange={handleInputChange}
                                    className="w-full" >
                                    <option value="">전체</option>
                                    <option value="1">1시간 이내</option>
                                    <option value="2">1시간 이상 2시간 이내</option>
                                    <option value="3">2시간 이상</option>
                                </select>
                            </td>
                            <th>미연결 구분</th>
                            <td>
                                <select
                                    name="searchGubun" // erroclscode
                                    id="searchGubun"
                                    onChange={handleInputChange}
                                    className="w-full" >
                                    <option value="">전체</option>
                                    {gubunList.map((gubun) =>
                                        <option key={gubun.bscdminr} value={gubun.bscdminr}>{gubun.bscddesc}</option>
                                    )}
                                </select>
                            </td>
                            <th>미연결 사유</th>
                            <td>
                                <select
                                    name="searchGubunS" // errocode 
                                    id="searchGubunS"
                                    onChange={handleInputChange}
                                    className="w-full">
                                    <option value="">전체</option>
                                    {reasonList.map((reason) =>
                                        <option key={reason.bscdminr} value={reason.bscdminr}>{reason.bscddesc}</option>
                                    )}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>미연결 기간</th>
                            <td colSpan={5}>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                reSearch={reSearch}
                setReSearch={setReSearch}
            />
            <div className='flex justify-between mb-2'>
                <p className='ml-2'>조회 기준 시간 : {lastDate ? lastDate : '····· Loading ·····'}</p>
                <p className='bold co_red'> * 입력된 미 전송 사유는 수정이 불가능 합니다. 최초 기입시 정확히 입력 해 주시기 바랍니다. </p>
            </div>
            <NotconnectreasonDataGrid
                propsInfo={propsInfo}
                state={state}
                modalOpen={modalOpen}
                setUpdateParams={setUpdateParams}
            />
        </Main>
    )
}

export default NotConnectReasonList